import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.step || initialState;

export const selectStep = createSelector(
  [selectSlice],
  state => state.currentStep,
);
